import { render, staticRenderFns } from "./user-report-card.vue?vue&type=template&id=3f0d1cb8&scoped=true"
import script from "./user-report-card.ts?vue&type=script&lang=ts&external"
export * from "./user-report-card.ts?vue&type=script&lang=ts&external"
import style0 from "./user-report-card.scss?vue&type=style&index=0&id=3f0d1cb8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0d1cb8",
  null
  
)

export default component.exports